import { roleAtLeast } from '../lib/roles';

/**
 * Layout's own nav already hides a link a role can't use, but hiding the
 * link doesn't stop a direct URL -- a bookmarked link, a shared URL, or a
 * lower-role member simply typing the path landed on the full page with
 * every control rendered and no indication anything was wrong until the
 * first API call came back 403. This is the actual gate; the nav filter
 * is just tidiness on top of it.
 *
 * Takes `role` as a prop rather than reading it via context itself, so
 * this stays a plain, standalone component with no dependency on App.jsx.
 */
export default function RequireRole({ role, minRole, children }) {
  if (roleAtLeast(role, minRole)) return children;
  return (
    <div className="full-page">
      <div className="boot-error">
        <h1>You don't have access to this page</h1>
        <p>This requires the {minRole} role or higher in this company. Ask an admin if you need it.</p>
      </div>
    </div>
  );
}
